import LabeledSelect from "./LabeledSelect";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {ComponentError} from "../ComponentLoader";
import {tryGetDynamicUiPages} from "../../redux/slices/dynamicUiSlice";

const DynamicPagesSelect = ({
                              label, value, onChange, type, placeholder = "Search Dynamic Pages",
                              emptyMsg = "No data", extData, ...props
                            }) => {


  const dispatch = useDispatch();
  const {loading, error, data, init} = useSelector((state) => state.dynamicUi.pages.info);

  useEffect(
    () => {
      if (!init && !error && !loading) {
        dispatch(tryGetDynamicUiPages({all: true}));
      }

    },
    [init, loading, error]
  );

  const _data = Object.values(data).filter(d => d.deletable);

  useEffect(() => {
    if (extData && init) {
      const page = _data.find((d) => d.id.toString() === extData);
      // onChange(data.find((d) => d.id.toString() === extData));
      if (page) {
        onChange(page);
      }
    }
  }, [init, extData]);

  return (
    error ? <ComponentError errorMsg={error} className="p-4 mb-2"
                            retry={() => dispatch(tryGetDynamicUiPages({all: true}))}/> :
      <LabeledSelect label={label} value={value} getOptionLabel={(option) => option.title} options={_data}
                     getOptionValue={(option) => option.id} placeholder={placeholder}
                     onChange={onChange} emptyMsg={emptyMsg} {...props} loading={loading}/>
  );
};

export default DynamicPagesSelect;
